// 将数字转换为星期
import { parseInt } from "core-js/fn/number";
import time from "js-time.js";

export function getWeek(num){
    if( num === 0 ) return '周日';
    else if( num === 1 ) return '周一';
    else if( num === 2 ) return '周二';
    else if( num === 3 ) return '周三';
    else if( num === 4 ) return '周四';
    else if( num === 5 ) return '周五';
    else if( num === 6 ) return '周六';
}


export function getWeekInLanguage(num,that){
    if( num === 0 ) return that.$t('common.sunday');
    else if( num === 1 ) return that.$t('common.monday');
    else if( num === 2 ) return that.$t('common.tuesday');
    else if( num === 3 ) return that.$t('common.wednesday');
    else if( num === 4 ) return that.$t('common.thursday');
    else if( num === 5 ) return that.$t('common.friday');
    else if( num === 6 ) return that.$t('common.saturday');
}

export function getMonthInLanguage(num,that){
    if( num === 0 ) return that.$t('common.month1');
    else if( num === 1 ) return that.$t('common.month2');
    else if( num === 2 ) return that.$t('common.month3');
    else if( num === 3 ) return that.$t('common.month4');
    else if( num === 4 ) return that.$t('common.month5');
    else if( num === 5 ) return that.$t('common.month6');
    else if( num === 6 ) return that.$t('common.month7');
	else if( num === 7 ) return that.$t('common.month8');
	else if( num === 8 ) return that.$t('common.month9');
	else if( num === 9 ) return that.$t('common.month10');
	else if( num === 10 ) return that.$t('common.month11');
	else if( num === 11 ) return that.$t('common.month12');
	
}
export function getMonthDayNum(sts){
     var date = new Date(sts);
     var year = date.getFullYear();
     var month = date.getMonth()+1;
     var d = new Date(year, month, 0);
     return d.getDate();
}

export function getYearDayNum(t){
       if (t==null){
				var Year = new Date().getFullYear(), s = 0, d;//获取当前年
				for (var i = 1; i < 13; i++) {
					d = new Date(Year, i, 0);//获取某一个月的天数
					s += d.getDate();
				};
				return s;
		} else if(t >= 1970) {
				var Year = new Date().getFullYear(), s = 0, d;
				for (var i = 1; i < 13; i++) {
					d = new Date(t, i, 0);
					s += d.getDate();
				};
				return s;
		} else {
			return "年份有误";
		} 
}

// 返回日、周、月、年对应的日期
export function getTypeTime(timestamp,type){
    // console.log(timestamp,type);

    if(  type=="日" ){
        return time(timestamp + 1000*4).format('HH:mm');       // 12:00
    }
    else if(  type=="周" ){
        return getWeek(  time(timestamp).day()  );   // 周一
    }
    else if(  type=="月" ){
        return time(timestamp).format('MM/DD');   // 11/3
    }
    else{
        return time(timestamp).format('M') + '月';                 // 11月
    }
}


// 返回日、周、月、年对应的日期
export function getTypeTimeLanguage(timestamp,type,that){
    // console.log(timestamp,type);

    if(  type=="日" ){
        return time(timestamp + 1000*4).format('HH:mm');       // 12:00
    }
    else if(  type=="周" ){
        return getWeekInLanguage(  time(timestamp).day() ,that );   // 周一
    }
    else if(  type=="月" ){
        return time(timestamp).format('MM/DD');   // 11/3
    }
    else{
        return  getMonthInLanguage(time(timestamp).month(),that);                 // 11月
    }
}


// 获取时间段  类型：日、周、月、年    标记时间戳：一般为现在时间    回调函数    依赖js-time.js插件
export function getLimits(type,newTime,callback){
    let start = " 00:00:00";
    let newTimeJson = time(newTime);    // time()为js-time.js插件中的方法
    /*newTimeJson: {   // 时间信息：年、月、日、周、时、分、秒
        "$d": "2020-11-03T04:01:11.046Z",
        "$y": 2020,
        "$M": 10,
        "$D": 3,
        "$W": 2,
        "$H": 12,
        "$m": 1,
        "$s": 11,
        "$ms": 46
    },*/

    let startTime = '';
    let endTime = '';

    if(  type=="日"  ){
        let str = time(newTime).format("YYYY-MM-DD");

        startTime = time(str + start).valueOf();
        endTime = startTime + 24*60*60*1000 - 1000;
    }
    else if(  type=="月"  ){
        let str = `${  newTimeJson['$y']  }-${  newTimeJson['$M']+1  }-01`;

        startTime = time(str + start).valueOf();
        endTime = startTime + time(startTime).monthDays()*24*60*60*1000 -1000;   // monthDays：每个月多少天
    }
    else if(  type=='年'  ){
        let str = `${  newTimeJson['$y']  }-01-01`;
        let str2 = `${  newTimeJson['$y']+1  }-01-01`;

        startTime = time(str + start).valueOf();
        endTime = time(str2 + start).valueOf() -1000;
    }
    else if(  type=="周"  ){
        // let num = new Date(newTime).getDay();
        let num = time(newTime).day();
        let week = [
            [0,6,"星期天"],
            [1,0,"星期一"],
            [2,1,"星期二"],
            [3,2,"星期三"],
            [4,3,"星期四"],
            [5,4,"星期五"],
            [6,5,"星期六"],
        ];

        let str = time(newTime).format("YYYY-MM-DD");
        startTime = time(str + start).valueOf() - 24*60*60*1000*week[num][1];
        endTime = startTime + 24*60*60*1000*7 - 1000;
    }

    if( callback ){  callback();  }

    return {  startTime,endTime  }

}

// 获取时间段  类型：日、周、月、年    标记时间戳：一般为现在时间    回调函数    依赖js-time.js插件
export function formatDateStringByMillSecond(newTime,formatStr){
    return time(newTime).format(formatStr);
}
export function getPressTypeLanguageStr(type,that){
	switch (type){
		case 'ylzs':
			return that.$t('measure.pressurePressureIndex');
		case 'tired':
			return that.$t('measure.pressureTired');
		case 'jsyl':
			return that.$t('measure.pressureSpirePressure');
		case 'kynl':
			return  that.$t('measure.pressureTolerance');
	}
	return   '';
}

export function getPressTypeValueLanguageStr(type,level,that){
	switch (type){
		case 'ylzs':
			switch (level){
				case 0:
					return that.$t('measure.good');
				case 1:
					return that.$t('measure.notBad');
				case 2:
					return that.$t('measure.Moderate');
				case 3:
					return that.$t('measure.poor');
			}
		case 'tired':
			switch (level){
				case 0:
					return that.$t('measure.easy');
				case 1:
					return that.$t('measure.tired');
				case 2:
					return that.$t('measure.fatigue');
			}
		case 'jsyl':
		case 'kynl':
			switch (level){
				case 0:
					return that.$t('measure.low');
				case 1:
					return that.$t('measure.medium');
				case 2:
					return that.$t('measure.high');
				case 3:
					return that.$t('measure.veryHigh');
			}
	}
	return   '';
}



export function getSportTypeLanguageStr(sportType,that){

	
	switch (sportType){
		case 1:
			return that.$t('sport.sportType1');
		case 2:
			return that.$t('sport.sportType2');
		case 3:
			return that.$t('sport.sportType3');
		case 4:
			return  that.$t('sport.sportType4');
		case 5:
			return that.$t('sport.sportType5');
		case  6:
			return that.$t('sport.sportType6');
		case 7:
			return that.$t('sport.sportType7');
		case 8:
			return  that.$t('sport.sportType8');
		case 9:
			return  that.$t('sport.sportType9');
		case 10:
			return  that.$t('sport.sportType10');
		case 11:
			return  that.$t('sport.sportType11');
		case 12:
			return  that.$t('sport.sportType12');
		case 13:
			return  that.$t('sport.sportType13');
		case 14:
			return  that.$t('sport.sportType14');
		case 15:
			return  that.$t('sport.sportType15');
		case 16:
			return  that.$t('sport.sportType16');
		case 17:
			return  that.$t('sport.sportType17');
		case 18:
			return  that.$t('sport.sportType18');
		case 19:
			return  that.$t('sport.sportType19');
		case 20:
			return  that.$t('sport.sportType20');
		case 21:
			return  that.$t('sport.sportType21');
		case 22:
			return  that.$t('sport.sportType22');
		case 23:
			return  that.$t('sport.sportType23');
		case 24:
			return  that.$t('sport.sportType24');
		case 25:
			return  that.$t('sport.sportType25');
		case 26:
			return  that.$t('sport.sportType26');
		case 27:
			return  that.$t('sport.sportType27');
		case 28:
			return  that.$t('sport.sportType28');
		case 29:
			return  that.$t('sport.sportType29');
		case 30:
			return  that.$t('sport.sportType30');
		case 31:
			return  that.$t('sport.sportType31');
		case 32:
			return  that.$t('sport.sportType32');
		case 33:
			return  that.$t('sport.sportType33');
		case 34:
			return  that.$t('sport.sportType34');
		case 35:
			return  that.$t('sport.sportType35');
	}
	return   that.$t('sportType1');
}

export function getSportTypeStr(sportType){
	switch (sportType){
		case 1:
			return '户外跑步';
		case 2:
			return '室内跑步';
		case 3:
			return  '户外步行'; 
		case 4:
			return  '室内步行';
		case 5:
			return '户外骑行';
		case  6:
			return '室内单车';
		case 7:
			return  '泳池游泳';
		case 8:
			return  '开发水域';
		case 9:
			return  '登山';
		case 10:
			return  '徒步';
		case 11:
			return  '越野跑';
		case 12:
			return  '高尔夫练习';
		case 13:
			return  '滑雪';
		case 14:
			return  '雪板滑雪';
		case 15:
			return  '越野滑雪';
		case 16:
			return  '铁人三项';
		case 17:
			return  '椭圆机';
		case 18:
			return  '划船';
		case 19:
			return  '跳绳';
		case 20:
			return  '羽毛球';
		case 21:
			return  '乒乓球';
		case 22:
			return  '网球';
		case 23:
			return '篮球';
		case 24:
			return  '足球';
		case 25:
			return  '棒球';
		case 26:
			return  '排球';
		case 27:
			return  '板球';
		case 28:
			return  '橄榄球';
		case 29:
			return  '曲棍球';
		case 30:
			return '跳舞';
		case 31:
			return  '动感单车';
		case 32:
			return  '瑜伽';
		case 33:
			return  '仰卧起坐';
		case 34:
			return  '体操';
		case 35:
			return  '开合跳';
	}
	return   '户外跑步';
}

export function getSportTypeImg(sportType){
	switch (sportType){
		case 1:
			return require('../assets/img/icon_sport_type_1.png');
		case 2:
			return require('../assets/img/icon_sport_type_2.png');
		case 3:
			return  require('../assets/img/icon_sport_type_3.png');
		case 4:
			return  require('../assets/img/icon_sport_type_4.png');
		case 5:
			return require('../assets/img/icon_sport_type_5.png');
		case  6:
			return require('../assets/img/icon_sport_type_6.png');
		case 7:
			return  require('../assets/img/icon_sport_type_7.png');
		case 8:
			return require('../assets/img/icon_sport_type_8.png');
		case 9:
			return  require('../assets/img/icon_sport_type_9.png');
		case 10:
			return  require('../assets/img/icon_sport_type_10.png');
		case 11:
			return  require('../assets/img/icon_sport_type_11.png');
		case 12:
			return  require('../assets/img/icon_sport_type_12.png');
		case 13:
			return  require('../assets/img/icon_sport_type_13.png');
		case 14:
			return  require('../assets/img/icon_sport_type_14.png');
		case 15:
			return  require('../assets/img/icon_sport_type_15.png');
		case 16:
			return  require('../assets/img/icon_sport_type_16.png');
		case 17:
			return  require('../assets/img/icon_sport_type_17.png');
		case 18:
			return  require('../assets/img/icon_sport_type_18.png');
		case 19:
			return  require('../assets/img/icon_sport_type_19.png');
		case 20:
			return  require('../assets/img/icon_sport_type_20.png');
		case 21:
			return  require('../assets/img/icon_sport_type_21.png');
		case 22:
			return  require('../assets/img/icon_sport_type_22.png');
		case 23:
			return require('../assets/img/icon_sport_type_23.png');
		case 24:
			return  require('../assets/img/icon_sport_type_24.png');
		case 25:
			return  require('../assets/img/icon_sport_type_25.png');
		case 26:
			return  require('../assets/img/icon_sport_type_26.png');
		case 27:
			return  require('../assets/img/icon_sport_type_27.png');
		case 28:
			return  require('../assets/img/icon_sport_type_28.png');
		case 29:
			return  require('../assets/img/icon_sport_type_29.png');
		case 30:
			return require('../assets/img/icon_sport_type_30.png');
		case 31:
			return  require('../assets/img/icon_sport_type_31.png');
		case 32:
			return  require('../assets/img/icon_sport_type_32.png');
		case 33:
			return  require('../assets/img/icon_sport_type_33.png');
		case 34:
			return  require('../assets/img/icon_sport_type_34.png');
		case 35:
			return  require('../assets/img/icon_sport_type_35.png');
	}
	return   require('../assets/img/icon_sport_type_0.png');
}

// 将字符串转变成成时间(str,type)   时间字符串   改写的字符串类型
export function stringToTimestamp(str='20201012', type="周"){
    // console.log("函数参数： ",str,type);

    let arr = str.split('');
    let year = arr[0] + arr[1] + arr[2] +arr[3];
    let month = arr[4] + arr[5];
    let date = arr[6] + arr[7];
    let hour = arr[8] + arr[9];
    let minite = (arr[10] && arr[11]) ? (arr[10] + arr[11]) : '00';

    if(  type=="年"  ){   // 202008
        var str2 = year + '-' + month + '-' + '16 00:00:00';    // 将时间卡在中间
    }
    else if(  type=="月"  ){  // 20201104
        var str2 = year + '-' + month + '-' + date + ' 12:00';
    }
    else if(  type=="周"  ){  // 20201109
        var str2 = year + '-' + month + '-' + date + ' 12:00';
    }
    else  if(  type=="日"  ){  //
        // var str2 = year + '-' + month + '-' + date + ' ' + hour + ':00';    // 2020120910  待处理--------
        var str2 = year + '-' + month + '-' + date + ' ' + hour + ':' + minite;    // 2020120910  待处理--------
    }
    return time(str2).valueOf();
}



// 数字格式化：去除非数字、添加逗号、设置小数点（默认无小数点）
export function fmoney(s, n=0) {
    s = String(s);

    if(  s===''  )  return "";    // 特殊情况，避免出现NaN

    n = n > 0 && n <= 20 ? n : 0;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    let l = s.split(".")[0].split("").reverse();
    if(  n>0  ){
        var r = s.split(".")[1];
    }

    let t = "";
    for ( let i = 0; i < l.length; i++) {
        t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
    }

    if(  n>0  )  return t.split("").reverse().join("") + "." + r;
    else   return t.split("").reverse().join("");
}


// 将步数转换成千卡卡路里
export function getKCalorie(steps) {
	let num = steps * 0.6 * 60 * 1.036 / 1000/ 1000;
	return num == 0 ? 0 : num.toFixed(2);
}

// 将步数转换成千卡卡路里
export function getKCalorie3(steps) {
	let num = steps * 0.6 * 60 * 1.036 / 1000/ 1000;
	return num == 0 ? 0 : num.toFixed(3);
}

// 将步数转换成卡路里
export function getCalorie(steps) {
	let num = steps * 0.6 * 60 * 1.036/ 1000;
	return num == 0 ? 0 : num.toFixed(2);
}



// 将步数转鸡蛋数
export function getEggNum(steps) {
	let num = steps * 0.6 * 60 * 1.036 / 1000 / 50;
	return num == 0 ? 0 : num.toFixed(2);
}


// 将步数转千米数
export function getDistance(steps) {
	let num = steps * 0.6 / 1000;
	return num == 0 ? 0 : num.toFixed(2);
}


// 将步数转换标准操作的圈数
export function getCircleNum(steps) {
	let num = steps*0.600/400
	return num == 0 ? 0 : num.toFixed(2);
}

// 将秒数转换成小时数
export function getHourBySecond(second) {
	let num = second/3600
	return parseInt(num);
}

// 将秒数转换成格式化小时数字符串
export function getHourBySecondStr(second) {
	let num = second/3600
	return parseInt(num)<10?('0'+parseInt(num)):parseInt(num);
}


// 将秒数转换成格式化分钟数字
export function getMinBySecond(second) {
	let num = second/60;
	return parseInt(num);
}

// 将秒数转换成格式化分钟数字符串
export function getMinBySecondNoHourStr(second) {
	let num = (second)/60;
	return parseInt(num)<10?('0'+parseInt(num)):parseInt(num);
}


//  将秒数转换成格式化分数字符串（不包括可以转成小时数）
export function getMinBySecondStr(second) {
	let num = (second%3600)/60;
	return parseInt(num)<10?('0'+parseInt(num)):parseInt(num);
}

// 将步数转换标准操作的圈数
export function getSecondBySecond(second) {
	let num = second%60;
	return num;
}

// 将步数转换标准操作的圈数
export function getSecondBySecondStr(second) {
	let num = second%60;
	return parseInt(num)<10?('0'+parseInt(num)):parseInt(num);
}



// 获取数组最后一项 (arr)
/*export function getArrLast(arr){
    let  len = arr.length;
    // console.log(arr[len - 1]);
    return arr[len - 1];
}*/




// rem转换成px值   值、是否反向操作
export function remToPx(num,isReverse=false){
    let  width1 = document.body.clientWidth;
    let  number = parseFloat(num);
    return isReverse ? 25*number*width1 : (width1/25)*number;
}
// px转换成rem值
export function pxToRem(num){
    let  width1 = document.body.clientWidth;
    let  number = parseFloat(num);
    return 25*number*width1;
}
// 获取1rem的px宽度
export function rem(){
    let  width1 = document.body.clientWidth;
    let  number = parseFloat(num);
    return width1/25;
}



// 用于组件的独有methods---------------------------------------------------------------------------------------------------------------------------------------------------------
export function isPC(){
    var u = navigator.userAgent;
    var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (u.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

// 被拖拽的对象，限制范围的父级，方向(x,y,xy)，是否是电脑端，回调函数       支持电脑端、移动端
export function drag(obj,parentObj=document.documentElement,direction="xy",isPc=true,scrollStartCallback,scrollCallback,scrollEndCallback) {
    if(  isPc  ){
        obj.onmousedown = function(ev) {
            if(  scrollStartCallback  ){  scrollStartCallback();  }

            var ev = ev || event;
            var disX = ev.clientX - obj.offsetLeft;   // 鼠标到当前对象的x距离 = 鼠标可视x坐标 - 当前元素到定位父级的x距离
            var disY = ev.clientY - obj.offsetTop;

            if ( obj.setCapture ) {    obj.setCapture();    }


            document.onmousemove = function(ev) {
                var ev = ev || event;
                var L = ev.clientX - disX;  // 当前元素到定位父级的x距离
                var T = ev.clientY - disY;

                if ( L < 0 ) {    L = 0;    }   //限制宽高的最小值、最大值
                else if ( L > parentObj.clientWidth - obj.offsetWidth ) {
                    L = parentObj.clientWidth - obj.offsetWidth;
                }

                if ( T < 0 ) {    T = 0;    }
                else if ( T > parentObj.clientHeight - obj.offsetHeight ) {
                    T = parentObj.clientHeight - obj.offsetHeight;
                }

                if(  direction.includes("x")  ){  obj.style.left = L + 'px';  }
                if(  direction.includes("y")  ){  obj.style.top = T + 'px';  }

                if(  scrollCallback  ){  scrollCallback();  }
            }

            document.onmouseup = function() {
                document.onmousemove = document.onmouseup = null;
                if ( obj.releaseCapture ) {  obj.releaseCapture();  }
                if( scrollEndCallback ){  scrollEndCallback();  }
            }

            return false;
        }

    }
    else{
        obj.ontouchstart = function(ev) {
            if(  scrollStartCallback  ){  scrollStartCallback();  }

            var ev = ev || event;
            var disX = ev.changedTouches[0].clientX - obj.offsetLeft;  // 鼠标到当前对象的x距离 = 鼠标可视x坐标 - 当前元素到定位父级的x距离
            var disY = ev.changedTouches[0].clientY - obj.offsetTop;

            if ( obj.setCapture ) {    obj.setCapture();    }


            document.ontouchmove = function(ev) {
                var ev = ev || event;
                var L = ev.changedTouches[0].clientX - disX;  // 当前元素到定位父级的x距离
                var T = ev.changedTouches[0].clientY - disY;

                if ( L < 0 ) {    L = 0;    }   //限制宽高的最小值、最大值
                else if ( L > parentObj.clientWidth - obj.offsetWidth ) {
                    L = parentObj.clientWidth - obj.offsetWidth;
                }

                if ( T < 0 ) {    T = 0;    }
                else if ( T > parentObj.clientHeight - obj.offsetHeight ) {
                    T = parentObj.clientHeight - obj.offsetHeight;
                }

                if(  direction.includes("x")  ){  obj.style.left = L + 'px';  }
                if(  direction.includes("y")  ){  obj.style.top = T + 'px';  }

                if(  scrollCallback  ){  scrollCallback();  }
            }

            document.ontouchend = function() {
                document.ontouchmove = document.ontouchend = null;
                if ( obj.releaseCapture ) {  obj.releaseCapture();  }
                if( scrollEndCallback ){  scrollEndCallback();  }
            }

            return false;
        }

    }

}



// 用于网页的独有methods----------------------------------------------------------------------------------------------------------------------------------------------------------
// x轴换算（将时间戳转换成x轴数据）     标记时间戳：一般为现在时间    x轴最大宽度    回调函数
export function xAxisComputeNibpReport(timestamp=time().valueOf(),startTime,endTime,width=300,callback){
	// console.log("timestamp: ",timestamp,',startTime =',startTime);
    // console.log("timestamp - startTime: ",timestamp - startTime);
	// console.log("endTime - startTime: ",endTime - startTime);
    let num = (timestamp - startTime) / (endTime - startTime);
    // console.log("width*num: ", Number((width*num).toFixed(2)));
    if(  callback  ){  callback();  }
    return Number((width*num).toFixed(2));
}

export function xAxisComputeSleepReport(timestamp,startTime,endTime,width=300,callback){
	// console.log("xAxisComputeSleepReport timestamp: ",timestamp,',startTime =',startTime);
    // console.log("xAxisComputeSleepReport timestamp - startTime: ",timestamp - startTime);
	// console.log("xAxisComputeSleepReport endTime - startTime: ",endTime - startTime);
    let num = (timestamp - startTime) / (endTime - startTime);
    // console.log("width*num: ", Number((width*num).toFixed(2)));
    if(  callback  ){  callback();  }
    return Number((width*num).toFixed(2));
}

export function xAxisComputeSportHrReport(timestamp=time().valueOf(),startTime,endTime,width=300,callback){
	// console.log("timestamp: ",timestamp,',startTime =',startTime,',width =',width);
	// console.log("endTime - startTime: ",endTime - startTime);
    let num = (timestamp) / (endTime - startTime);
    // console.log("width*num: ", Number((width*num).toFixed(2)),"num: ", num);
    if(  callback  ){  callback();  }
    return Number((width*num).toFixed(2));
}
export function xAxisComputeSportHrTimemapReport(timestamp=time().valueOf(),startTime,endTime,width=300,callback){
	// console.log("timestamp: ",timestamp,',startTime =',startTime,',width =',width);
	// console.log("endTime - startTime: ",endTime - startTime);
    let num = (timestamp-startTime) / (endTime - startTime);
    // console.log("width*num: ", Number((width*num).toFixed(2)),"num: ", num);
    if(  callback  ){  callback();  }
    return Number((width*num).toFixed(2));
}


export function xAxisComputeSportHrHexReport(timestamp=time().valueOf(),startTime,endTime,width=300,callback){
	// console.log("timestamp: ",timestamp*1000,',startTime =',startTime,',width =',width,',endTime =',endTime);
	// console.log("endTime - startTime: ",endTime - startTime);
	// console.log("timestamp - startTime: ",timestamp*1000 - startTime);
    let num = (timestamp*1000-startTime) / (endTime - startTime);
    // console.log("width*num: ", Number((width*num).toFixed(2)),"num: ", num);
    if(  callback  ){  callback();  }
    return Number((width*num).toFixed(2));
}


// x轴换算（将时间戳转换成x轴数据）    类型：日、周、月、年    标记时间戳：一般为现在时间    x轴最大宽度    回调函数
export function xAxisCompute(timestamp=time().valueOf(),type="日",width=300,callback){
    let json = {};
    json = getLimits(type,timestamp);  // methods定义的方法：获取时间段

    let num = (timestamp - json["startTime"]) / (json["endTime"] - json["startTime"]);

    // console.log("num: ",num);
    // console.log("width*num: ", Number((width*num).toFixed(2)));
    if(  callback  ){  callback();  }
    return Number((width*num).toFixed(2));
}

// x轴换算 xAxisCompute的反向逻辑
export function xAxisCompute2(x,startTime=0,endTime=300,width=300){
    // 处理x值为0的特殊情况
    /*if(  x===undefined  ){  return "-"  }   // 未赋值时，进行初始化
    else if( x===0 )  return startTime;
    else if( x>0 )  return Math.round(x/width*(endTime-startTime)+startTime);
    else  return x;*/
	// console.log("xAxisCompute2 x: ",x,"   startTime=",startTime,"   endTime="+endTime);
    return Math.round(x/width*(endTime-startTime)+startTime);
}


// y轴换算  max:y:min 对应 height:newY:0
export function yAxisCompute(y,min=0,max=300,height=300){
	// console.log("y: ",y,min,max);
    return (y-min)/(max-min)*height;
}

// y轴换算 xAxisCompute的反向逻辑
export function yAxisCompute2(y,min=0,max=300,height=300,isInt=true){
    // 处理y值为0的特殊情况
    if(  y===undefined  ){  return ""  }   // 未赋值时，进行初始化
    else if( y===0 )  return min;
    else if( y>0 )  return  isInt  ?  Math.round(y/height*(max-min)+min)  :  (y/height*(max-min)+min);
    else  return y;
}



export function arrAv(arr,num=2) {
	if(  !arr.length>0  ){
		return '--'
	}
	else{
		var sum = eval(arr.join(" + "));
		return (sum / arr.length).toFixed(num); 
	}
    
}



export function getYAxiosArr(arr = [36,37],num=0,minDistance=5,onoff=false){
	console.log("arr: ",arr);
	
	/* let arr1 = [];
	for(  let i=0; i<arr.length;i++  ){
		if(  arr[i]["y"] && arr[i]["y"]!=0  )  arr1.push(arr[i]["y"]);
		if(  arr[i]["y2"] && arr[i]["y2"]!=0  )  arr1.push(arr[i]["y2"]);
		if(  arr[i]["y3"] && arr[i]["y3"]!=0  )  arr1.push(arr[i]["y3"]);
		if(  arr[i]["y4"] && arr[i]["y4"]!=0  )  arr1.push(arr[i]["y4"]);
	} */
	
	
	// let num = 1;
	// console.log("arr1: ",arr1);
	
	let arr2 = arr.sort(function ( a, b ) {  return a - b;  });
	let min = Math.floor(arr2[0] - num);
	let max = Math.ceil(arr2.slice(-1)[0] + num);
	let distance = max - min;				
	
	// console.log("min: ",min);
	// console.log("max: ",max);
	// console.log("distance: ",distance);
	
	if(  onoff  ){
		distance =  Math.ceil(distance/minDistance)*minDistance;
		max = min + distance;
	}
	
	// console.log("min: ",min);
	// console.log("max: ",max);
	// console.log("distance: ",distance);
	
	let distance2 = distance / 5;
	let arr3 = [min, min+distance2*1, min+distance2*2, min+distance2*3, min+distance2*4, min+distance2*5];
	
	console.log("arr3: ",arr3);
	return arr3;
}


//json转换成url参数
export function jsonToParams(json1) {
	//let  json1 = {code1: "XDM00001", code2: "YQM40150"};
	let arr1 = [];
	for (var i in json1) {
		arr1.push(i + '=' + json1[i]);
	}
	return arr1.join('&');
}



// 检测异常数据（血压、血氧、心率）
export function checkAbnormal(json, type) {
	var returnJson = {
		isNormal: true, // 是否正常
		// isNormal2: true, // 是否正常
		info: '正常',
		level:0,
	};

	if (type === "BP") {
		if ((json.sys >= 130 && json.sys <= 139) || (json.dia >= 85 && json.dia <= 89)) {
			returnJson.info = '正常高值血压';
			returnJson.isNormal = false;
			returnJson.level = 1;
		}
		if ((json.sys >= 140 && json.sys <= 159) || (json.dia >= 90 && json.dia <= 99)) {
			returnJson.info = '1级高血压';
			returnJson.isNormal = false;
			returnJson.level = 2;
		}
		if (json.sys >= 160 || json.dia >= 100) {
			returnJson.info = '2级高血压';
			returnJson.isNormal = false;
			returnJson.level = 3;
		}
	}else if (type === "NewBP") {
		if ((json.avgSys >= 130 && json.avgSys <= 139) || (json.avgDia >= 85 && json.avgDia <= 89)) {
			returnJson.info = '正常高值血压';
			returnJson.isNormal = false;
			returnJson.level = 1;
		}
		if ((json.avgSys >= 140 && json.avgSys <= 159) || (json.avgDia >= 90 && json.avgDia <= 99)) {
			returnJson.info = '1级高血压';
			returnJson.isNormal = false;
			returnJson.level = 2;
		}
		if (json.avgSys >= 160 || json.avgDia >= 100) {
			returnJson.info = '2级高血压';
			returnJson.isNormal = false;
			returnJson.level = 3;
		}
	}  else if (type === "BO") {
		if (json.spo2 < 95) {
			returnJson.info = '异常';
			returnJson.isNormal = false;
		}
	} else if (type === "HR") {
		if (json.hr >= 120 && json.hr <= 150) {
			returnJson.info = '偏快';
			returnJson.isNormal = false;
		} else if (json.hr >= 100 && json.hr < 120) {
			returnJson.info = '稍快';
			returnJson.isNormal = false;
		}
		/*else if(  json.hr>=60 && json.hr<100  ){
		    returnJson.info = '正常';
		    returnJson.isNormal = true;
		}*/
		else if (json.hr >= 50 && json.hr < 60) {
			returnJson.info = '较慢';
			returnJson.isNormal = false;
		} else if (json.hr < 50 || json.hr > 150) {
			returnJson.info = '异常';
			returnJson.isNormal = false;
		}
	}
	/* else if (type === "P") {
		if (json.ylzs >= 0 && json.ylzs <= 33) {
			returnJson.info = '轻松';
			returnJson.isNormal = false;
		} else if (json.ylzs >= 34 && json.ylzs <= 66) {
			returnJson.info = '较累';
			returnJson.isNormal = false;
		} else if (json.ylzs >= 67 && json.ylzs <= 100) {
			returnJson.info = '疲劳';
			returnJson.isNormal = false;
		}
	} */

	return returnJson;
}

// 检测异常数据（血压、血氧、心率）
export function checkAbnormalLanguage(json, type,that) {
	var returnJson = {
		isNormal: true, // 是否正常
		// isNormal2: true, // 是否正常
		info: that.$t('common.normal'),
		level:0,
	};

	if (type === "BP") {
		if ((json.sys >= 130 && json.sys <= 139) || (json.dia >= 85 && json.dia <= 89)) {
			returnJson.info = that.$t('measure.bloodPressureNormalHigh');
			returnJson.isNormal = false;
			returnJson.level = 1;
		}
		if ((json.sys >= 140 && json.sys <= 159) || (json.dia >= 90 && json.dia <= 99)) {
			returnJson.info =that.$t('measure.bloodPressureHighLevelOne') ;
			returnJson.isNormal = false;
			returnJson.level = 2;
		}
		if (json.sys >= 160 || json.dia >= 100) {
			returnJson.info = that.$t('measure.bloodPressureHighLevelTwo');
			returnJson.isNormal = false;
			returnJson.level = 3;
		}
	}else if (type === "NewBP") {
		if ((json.avgSys >= 130 && json.avgSys <= 139) || (json.avgDia >= 85 && json.avgDia <= 89)) {
			returnJson.info =that.$t('measure.bloodPressureNormalHigh');
			returnJson.isNormal = false;
			returnJson.level = 1;
		}
		if ((json.avgSys >= 140 && json.avgSys <= 159) || (json.avgDia >= 90 && json.avgDia <= 99)) {
			returnJson.info =that.$t('measure.bloodPressureHighLevelOne') ;
			returnJson.isNormal = false;
			returnJson.level = 2;
		}
		if (json.avgSys >= 160 || json.avgDia >= 100) {
			returnJson.info = that.$t('measure.bloodPressureHighLevelTwo');
			returnJson.isNormal = false;
			returnJson.level = 3;
		}
	}  else if (type === "BO") {
		if (json.spo2 < 95) {
			returnJson.info = that.$t('common.abnormal');
			returnJson.isNormal = false;
		}
	} else if (type === "HR") {
		if (json.hr >= 120 && json.hr <= 150) {
			returnJson.info = that.$t('measure.fast');
			returnJson.isNormal = false;
		} else if (json.hr >= 100 && json.hr < 120) {
			returnJson.info =that.$t('measure.lightFast');
			returnJson.isNormal = false;
		}
		/*else if(  json.hr>=60 && json.hr<100  ){
		    returnJson.info = '正常';
		    returnJson.isNormal = true;
		}*/
		else if (json.hr >= 50 && json.hr < 60) {
			returnJson.info =that.$t('measure.lightSlow');
			returnJson.isNormal = false;
		} else if (json.hr < 50 || json.hr > 150) {
			returnJson.info =that.$t('common.abnormal');
			returnJson.isNormal = false;
		}
	}
	/* else if (type === "P") {
		if (json.ylzs >= 0 && json.ylzs <= 33) {
			returnJson.info = '轻松';
			returnJson.isNormal = false;
		} else if (json.ylzs >= 34 && json.ylzs <= 66) {
			returnJson.info = '较累';
			returnJson.isNormal = false;
		} else if (json.ylzs >= 67 && json.ylzs <= 100) {
			returnJson.info = '疲劳';
			returnJson.isNormal = false;
		}
	} */

	return returnJson;
}

// 检测异常数据(压力)
export function checkAbnormalLanguage2(num, type,that) {
	var returnJson = {
		isNormal: true, // 是否正常
		info: that.$t('common.normal'),
	};


	// 压力指数
	if (type === "ylzs") {
		if (num >= 0 && num <= 25) {
			returnJson.info = that.$t('measure.good');
			returnJson.isNormal = true;
		}
		if (num >= 26 && num <= 50) {
			returnJson.info = that.$t('measure.notBad');
			returnJson.isNormal = true;
		}
		if (num >= 51 && num <= 75) {
			returnJson.info =that.$t('measure.Moderate') ;
			returnJson.isNormal = true;
		}
		if (num >= 76 && num <= 100) {
			returnJson.info =that.$t('measure.poor');
			returnJson.isNormal = false;
		}
	}
	// 疲劳度
	else if (type === "tired") {
		if (num >= 0 && num <= 33) {
			returnJson.info =that.$t('measure.easy') ;
			returnJson.isNormal = true;
		}
		if (num >= 34 && num <= 66) {
			returnJson.info =that.$t('measure.tired') ;
			returnJson.isNormal = true;
		}
		if (num >= 67 && num <= 100) {
			returnJson.info =that.$t('measure.fatigue');
			returnJson.isNormal = false;
		}
	}
	// 精神压力  // 抗压能力
	else if (type === "jsyl"||type === "kynl") {
		if (num >= 0 && num <= 25) {
			returnJson.info =that.$t('measure.low') ;
			returnJson.isNormal = true;
		}
		if (num >= 26 && num <= 50) {
			returnJson.info =that.$t('measure.medium');
			returnJson.isNormal = true;
		}
		if (num >= 51 && num <= 75) {
			returnJson.info =that.$t('measure.high');
			returnJson.isNormal = false;
		}
		if (num >= 76 && num <= 100) {
			returnJson.info =that.$t('measure.veryHigh');
			returnJson.isNormal = false;
		}
	}
	


	return returnJson;
}


// 检测异常数据(压力)
export function checkAbnormal2(num, type) {
	var returnJson = {
		isNormal: true, // 是否正常
		// isNormal2: true, // 是否正常
		info: '正常',
		// info2: '正常',
	};


	// 压力指数
	if (type === "P"||type === "ylzs") {
		if (num >= 0 && num <= 25) {
			returnJson.info = '良好';
			returnJson.isNormal = true;
		}
		if (num >= 26 && num <= 50) {
			returnJson.info = '尚好';
			returnJson.isNormal = true;
		}
		if (num >= 51 && num <= 75) {
			returnJson.info = '中等';
			returnJson.isNormal = true;
		}
		if (num >= 76 && num <= 100) {
			returnJson.info = '较差';
			returnJson.isNormal = false;
		}
	}
	// 疲劳度
	else if (type === "P2"||type === "tired") {
		if (num >= 0 && num <= 33) {
			returnJson.info = '轻松';
			returnJson.isNormal = true;
		}
		if (num >= 34 && num <= 66) {
			returnJson.info = '较累';
			returnJson.isNormal = true;
		}
		if (num >= 67 && num <= 100) {
			returnJson.info = '疲劳';
			returnJson.isNormal = false;
		}
	}
	// 精神压力
	else if (type === "P3"||type === "jsyl") {
		if (num >= 0 && num <= 25) {
			returnJson.info = '低';
			returnJson.isNormal = true;
		}
		if (num >= 26 && num <= 50) {
			returnJson.info = '中';
			returnJson.isNormal = true;
		}
		if (num >= 51 && num <= 75) {
			returnJson.info = '高';
			returnJson.isNormal = false;
		}
		if (num >= 76 && num <= 100) {
			returnJson.info = '很高';
			returnJson.isNormal = false;
		}
	}
	// 抗压能力
	else if (type === "P4"||type === "kynl") {
		if (num >= 0 && num <= 25) {
			returnJson.info = '低';
			returnJson.isNormal = false;
		} else if (num >= 26 && num <= 50) {
			returnJson.info = '中';
			returnJson.isNormal = true;
		} else if (num >= 51 && num <= 75) {
			returnJson.info = '高';
			returnJson.isNormal = true;
		} else if (num >= 76 && num <= 100) {
			returnJson.info = '很高';
			returnJson.isNormal = true;
		}
	}

	return returnJson;
}

// 检测异常数据（心血管整体结果）
export function checkAbnormal3(num) {
	let json1 = {
		"1": "心血管系统正常",
		"2": "血压正常、心率正常，血管系统有风险",
		"3": "血压正常、心率过快，血管系统正常",
		"4": "血压正常、心率过快，血管系统有风险",
		"5": "血压正常、心率过慢，血管系统正常",
		"6": "血压正常、心率过慢，血管系统有风险",
		"7": "血压正常、心率不齐，血管系统正常",
		"8": "血压正常、心率不齐，血管系统有风险",
		"9": "血压偏高、心率正常，血管系统正常",
		"10": "血压偏高、心率正常，血管系统有风险",
		"11": "血压偏高、心率过快，血管系统正常",
		"12": "血压偏高、心率过快，血管系统有风险",
		"13": "血压偏高、心率过慢，血管系统正常",
		"14": "血压偏高、心率过慢，血管系统有风险",
		"15": "血压偏高、心率不齐，血管系统正常",
		"16": "血压偏高、心率不齐，血管系统有风险",
		"17": "血压偏低、心率正常，血管系统正常",
		"18": "血压偏低、心率正常，血管系统有风险",
		"19": "血压偏低、心率过快，血管系统正常",
		"20": "血压偏低、心率过快，血管系统有风险",
		"21": "血压偏低、心率过慢，血管系统正常",
		"22": "血压偏低、心率过慢，血管系统有风险",
		"23": "血压偏低、心率不齐，血管系统正常",
		"24": "血压偏低、心率不齐，血管系统有风险"
	};
	var returnJson = {
		isNormal: true, // 是否正常
		info: '正常',
		num,
	};

	if (num != 1) {
		returnJson.isNormal = false;
	}
	returnJson.info = json1[num];

	return returnJson;
}

